import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import classNames from 'classnames';
import MobileHeader from '../../components/MobileHeader/MobileHeader';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import Modal from 'react-bootstrap/lib/Modal';
import Input from 'react-bootstrap/lib/Input';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';
import ChoiceBox from '../../components/ChoiceBox/ChoiceBox';
import Loader from '../../components/Loader/Loader';


const Register = React.createClass({
    mixins: [LinkedStateMixin, ReactFireMixin],

    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    getInitialState() {
        return {
            email: '',
            password: '',
            school: false,
            showTermsModal: false,
            termModalToNext: false,
            hideLoader: true
        };
    },

    componentWillMount() {
        let auth = firebaseRoot.getAuth();
        if (auth) {
            this.bindAsDataSnapshot(firebaseRoot.child("users").child(auth.uid), "userRef");
        }
    },

    register() {
        this.setState({hideLoader: false});
        const email = this.state.email;
        const password = this.state.password;
        const school = this.state.school;
        // TODO(dunfalk): move create user to last step in signup
        firebaseRoot.createUser({email, password}, (error, userData) => {
            firebaseRoot.authWithPassword({email, password}, (error, auth) => {
                if (error) {
                    console.log(error);
                    // TODO(tirsen): Handle all the different error states.
                    return this.setState({error: error});
                }
                firebaseRoot.child('users').child(auth.uid).set({
                    provider: auth.provider,
                    email: email
                }, (error) => {
                    if (error) {
                        console.log(error);
                    }
                }).then(() => {
                    this.setState({hideLoader: true});
                    window.location.href = "/signup/profile";
                    //I used window.location.href because the page needs a reload for userRef, and I double checked with Johnne and he thinks it looks fine like this with the loader.
                    // I tried this.context.history.push('/signup/profile) which does not requires reload but I did not manage it to work, if any of you have better ideas, feel free!
                });
            });
        });
    },

    handleClickStart() {
        this.setState({
            termModalToNext: true,
            showTermsModal: true
        });
    },

    handleClickTerms() {
        this.setState({
            showTermsModal: true,
            termModalToNext: false
        })
    },

    render() {
        if (this.state.userRef && this.state.userRef.exists()) {
            return (
                <div>
                    <br/><p>Du är redan inloggad</p>
                    Återgå till <TouchLink to="/">startsidan</TouchLink><br/>
                    Eller <TouchLink to="/logout">logga ut</TouchLink>.
                </div>
            );
        }
        let hideTermsModal = () => this.setState({showTermsModal: false});
        let loaderClass = classNames({
            'hidden': this.state.hideLoader
        });

        return (
            <div className="screen-wrap">
                <MobileHeader
                    lessonId={this.props.params.lessonId}
                    problemId={this.props.params.problemId}
                    bookId={this.props.params.bookId}
                    type='signup'
                    // Don't show the back button on the root screen.
                    backButton={this.props.location.pathname.length > 1}
                />
                <div style={{ 'textAlign': 'center'}} className={loaderClass}><Loader/></div>
                <div className="screen-content">
                    <form className="section-wrap">
                        <div className="section-body">
                            <div className="albert-logo"></div>
                            <div className="section-form">
                                {this.state.error && <p className="text-danger">{this.state.error.message}</p>}
                                <FormSection>
                                    <FormGroup label="Email">
                                        <Input type="email" valueLink={this.linkState('email')} required/>
                                    </FormGroup>
                                    <FormGroup label="Password">
                                        <Input type="password" valueLink={this.linkState('password')} required/>
                                    </FormGroup>
                                </FormSection>
                                <FormSection>
                                    <Input type="checkbox" label="Sign in via skola"
                                           checkedLink={this.linkState('school')}/>
                                </FormSection>
                            </div>
                        </div>
                        <div className="section-footer">
                            <TouchButton bsStyle="primary" bsSize="large" onClick={this.handleClickStart} block>Let's
                                start</TouchButton>
                            <TouchButton bsStyle="link" onClick={this.handleClickTerms} block>Terms</TouchButton>
                            <TermsModal
                                show={this.state.showTermsModal}
                                onHide={hideTermsModal}
                                nextStep={this.state.termModalToNext}
                                handleAccept={this.register}
                            />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
});

const TermsModal = React.createClass({
    handleOnClickAccept(){
        this.props.onHide();
        this.props.handleAccept();
    },
    render() {
        let nextStep = this.props.nextStep;
        let buttons = null;

        if (nextStep) {
            buttons = <div><TouchButton bsStyle="link" onClick={this.props.onHide}>Close</TouchButton><TouchButton
                className="btn btn-primary" onClick={this.handleOnClickAccept} >Accept</TouchButton></div>;
        } else {
            buttons = <TouchButton bsStyle="primary" onClick={this.props.onHide}>Close</TouchButton>;
        }

        return (
            <Modal
                {...this.props}
                bsSize="large"
            >
                <Modal.Body>
                    <h3>Terms of use</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Distinctio placeat quos velit vitae
                        voluptates! Aliquid dolor et fuga inventore. Cum distinctio quod sit! Blanditiis eaque ex
                        laborum minus nisi nostrum, obcaecati odit officia placeat sequi tempora totam vel voluptate? Ea
                        eaque odio repellat tempora? Aliquid amet aspernatur, eveniet maiores molestias nostrum officia
                        quia suscipit unde! Aliquid amet at blanditiis eaque eius est inventore molestias quod, ratione
                        unde! Fugit laudantium numquam quis sint. Aliquam eaque officia sapiente sit velit? Adipisci
                        cupiditate deserunt dicta est eveniet facilis iure laboriosam neque nesciunt nisi nostrum odio,
                        odit optio quaerat quas quasi quis quo reiciendis repudiandae temporibus. Deleniti excepturi
                        optio perferendis quo! Deserunt praesentium, sapiente. Alias aliquam aliquid cum, cumque
                        cupiditate doloribus eligendi esse est id inciduntveniam.</p>
                </Modal.Body>
                <Modal.Footer>
                    {buttons}
                </Modal.Footer>
            </Modal>
        );
    }
});

export default Register;


/** WEBPACK FOOTER **
 ** ./src/screens/signup/SignupStart.js
 **/